import { useHttpClient } from "../http-client";
import { useAuth } from "../../components/auth-routes-provider";
import { useQuery } from "@tanstack/react-query";

interface ApiCurrentUser {
  id: string;
  type: "users";
  attributes: {
    email: string;
    admin: boolean;
    qc_supervisor: boolean;
    tagger_is_qcer: boolean;
  };
}

export const useGetCurrentUserApi = () => {
  const httpClient = useHttpClient();
  const auth = useAuth();

  const getCurrentUser = async ({
    signal,
  }: {
    signal: AbortSignal;
  }): Promise<ApiCurrentUser> => {
    if (!auth) {
      throw new Error("Auth not available");
    }

    const result = await httpClient.get(
      "/classifier/users/" + auth.idTokenPayload.sub,
      { signal }
    );

    if (!result?.data?.data) {
      throw new Error("User data not found in API response");
    }

    return result.data.data;
  };

  return useQuery({
    queryKey: ["users", auth?.idTokenPayload.sub ?? ""],
    queryFn: getCurrentUser,
    staleTime: Infinity,
    enabled: !!auth && !!auth.idTokenPayload?.sub,
  });
};
